export default __webpack_public_path__ + "static/freya-matthiessen-64e93f2424f794302bd2f092f986bdc5.jpg";